export enum Gender {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other',
  PreferNotToSay = 'Prefer not to say',
}

export enum EducationLevel {
  NoSchooling = 'No schooling completed',
  Primary = 'Primary school',
  Secondary = 'Secondary school',
  SomeHighSchool = 'Some high school, no matric certificate',
  Matric = 'Matric',
  Vocational = 'Trade / technical / vocational training (at a TVET, FET or private college)',
  Bachelors = 'University bachelor’s degree',
  Honours = 'University honours degree',
  Masters = 'Master’s degree',
  Professional = 'Professional degree (Law, Medicine, PhD)',
}

export enum AgreeDisagreeScale {
  StronglyDisagree = 'Strongly Disagree',
  Disagree = 'Disagree',
  Neutral = 'Neutral',
  Agree = 'Agree',
  StronglyAgree = 'Strongly Agree',
}

export enum EmploymentStatus {
  Searching = 'Searching for a job',
  NotSearching = 'Not actively searching for a job',
  FullTime = 'Full-time employed',
  PartTime = 'Part-time employed',
  Freelancing = 'Freelancing / Gig Work ',
  OwnBusiness = 'Running own business / Self-employed',
  Internship = 'Internship / Apprenticeship',
  SkillsTraining = 'Skills training/ Certification course',
  Studying = 'Studying',
}

export enum TimeRange {
  LessThanOneMonth = 'Less than one month',
  AboutOneMonth = 'About one month',
  TwoThreeMonths = '2-3 months',
  FourSixMonths = '4-6 months',
  SixMonthsOneYear = '6 months – 1 year',
  MoreThanOneYear = 'More than 1 year',
  MoreThanTwoYears = 'More than 2 years',
  MoreThanFiveYears = 'More than 5 years',
}

export enum HadJobTimeRange {
  OneSixMonths = '1-6 months',
  SixMonthsOneYear = '6-12 months',
  MoreThanOneYear = 'More than 1 year',
  MoreThanTwoYears = 'More than 2 years',
  MoreThanFiveYears = 'More than 5 years',
}

export enum LongestHighestPaidPostion {
  Longest = 'Longest held',
  Highest = 'Highest paid',
  Both = 'Both',
}

export enum JobSector {
  Architecture = 'Architecture and Engineering',
  Arts = 'Arts, Design, Entertainment, Sport',
  Maintenance = 'Building and Grounds Cleaning and Maintenance',
  Entrepreneurship = 'Entrepreneurship/ Self-employment',
  FinOps = 'Financial Operations',
  CommunityService = 'Community and Social Service',
  CompMath = 'Computer and Mathematical',
  Construction = 'Construction and Extraction',
  Instruction = 'Educational Instruction and Library',
  Farming = 'Farming, Fishing, and Forestry',
  Food = 'Food Preparation and Serving Related',
  Healthcare = 'Healthcare Practitioners and Technical',
  HealthcareSupport = 'Healthcare Support',
  Installation = 'Installation, Maintenance, and Repair',
  Legal = 'Legal',
  LifePhysSocialScience = 'Life, Physical, and Social Science',
  Management = 'Management',
  AdminSupport = 'Office and Administrative Support',
  PersonalCare = 'Personal Care and Service',
  Production = 'Production',
  Protective = 'Protective Service',
  Sales = 'Sales and Related',
  Transportation = 'Transportation and Material Moving',
  Other = 'Other',
}

export enum PlannedCourses {
  VisualSpatialWorkingMemory = 'Visual-spatial Working memory',
  Adaptability = 'Adaptability',
  Persistence = 'Persistence',
  ProblemSolving = 'Problem Solving',
  Speed = 'Speed',
  RiskPropensity = 'Risk Propensity',
  EmotionalIntelligence = 'Emotional Intelligence',
  Personality = 'Personality',
  CareerInterests = 'Career Interests',
  RunningYourOwnBusiness = 'Running your own business',
  Financial = 'Financial',
  SmallBusinessMarketing = 'Small Business Marketing',
  SocialMediaMarketing = 'Social Media Marketing',
  GrowthMindset = 'Growth Mindset',
  Programming = 'Programming',
  DataAnalysisInExcel = 'Data Analysis in Excel',
  MentoringPlatformForEntrepreneurs = 'Mentoring Platform for Entrepreneurs',
}

export enum HowMany {
  ZERO = '0',
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4',
  FIVE = '5',
  SIX = '6',
  SEVEN = '7',
  EIGHT = '8',
  NINE = '9',
  TEN = '10',
  ELEVEN = '11',
  TWELVE = '12',
  THIRTEEN = '13',
  FOURTEEN = '14',
  FIVETEEN = '15',
  SIXTEEN = '16',
  SEVENTEEN = '17',
  EIGHTEEN = '18',
  NINETEEN = '19',
  TWENTY = '20',
  TWENTY_ONE = '21',
  TWENTY_TWO = '22',
  TWENTY_THREE = '23',
  TWENTY_FOUR = '24',
  TWENTY_FIVE = '25',
  TWENTY_SIX = '26',
  TWENTY_SEVEN = '27',
  TWENTY_EIGHT = '28',
  TWENTY_NINE = '29',
  THIRTY = '30',
  THIRTY_ONE = '31',
  THIRTY_TWO = '32',
  THIRTY_THREE = '33',
  THIRTY_FOUR = '34',
  THIRTY_FIVE = '35',
  THIRTY_SIX = '36',
  THIRTY_SEVEN = '37',
  THIRTY_EIGHT = '38',
  THIRTY_NINE = '39',
  FOURTY = '40',
  // SIX_TO_TEN = '6-10',
  // TEN_TO_FIFTEEN = '10-15',
  // SIXTEEN_TO_TWENTY = '16-20',
  // TWENTY_ONE_TO_THIRTY = '21-30',
  // THIRTY_ONE_TO_FORTY = '31-40',
  // MORE_THAN_FORTY = 'more than 40',
}

export enum YesOrNo {
  Yes = 'yes',
  No = 'no',
}

export enum YesNoPlanTo {
  Yes = 'yes',
  No = 'no',
  PlanTo = 'plan to',
}

export enum FivePointScale {
  NotAtAll = '1',
  MostlyNot = '2',
  Some = '3',
  MostlyYes = '4',
  ALot = '5',
}

export enum PlanToIncreaseJobSearch {
  Yes = 'yes',
  SameAsBefore = 'same as before',
  No = 'no',
  NotApplicable = 'not applicable',
}

export enum Country {
  AF = 'Afghanistan',
  AX = 'AlandIslands',
  AL = 'Albania',
  DZ = 'Algeria',
  AS = 'American Samoa',
  AD = 'Andorra',
  AO = 'Angola',
  AI = 'Anguilla',
  AQ = 'Antarctica',
  AG = 'Antigua and Barbuda',
  AR = 'Argentina',
  AM = 'Armenia',
  AW = 'Aruba',
  AU = 'Australia',
  AT = 'Austria',
  AZ = 'Azerbaijan',
  BS = 'Bahamas',
  BH = 'Bahrain',
  BD = 'Bangladesh',
  BB = 'Barbados',
  BY = 'Belarus',
  BE = 'Belgium',
  BZ = 'Belize',
  BJ = 'Benin',
  BM = 'Bermuda',
  BT = 'Bhutan',
  BO = 'Bolivia',
  BA = 'Bosnia and Herzegovina',
  BW = 'Botswana',
  BV = 'Bouvet Island',
  BR = 'Brazil',
  IO = 'British Indian Ocean Territory',
  BN = 'Brunei Darussalam',
  BG = 'Bulgaria',
  BF = 'Burkina Faso',
  BI = 'Burundi',
  KH = 'Cambodia',
  CM = 'Cameroon',
  CA = 'Canada',
  CV = 'Cape Verde',
  KY = 'Cayman Islands',
  CF = 'Central African Republic',
  TD = 'Chad',
  CL = 'Chile',
  CN = 'China',
  CX = 'Christmas Island',
  CC = 'Cocos Keeling Islands',
  CO = 'Colombia',
  KM = 'Comoros',
  CG = 'Congo',
  CD = 'Congo Democratic Republic',
  CK = 'Cook Islands',
  CR = 'Costa Rica',
  CI = 'CoteDIvoire',
  HR = 'Croatia',
  CU = 'Cuba',
  CW = 'Curaçao',
  CY = 'Cyprus',
  CZ = 'CzechRepublic',
  DK = 'Denmark',
  DJ = 'Djibouti',
  DM = 'Dominica',
  DO = 'Dominican Republic',
  EC = 'Ecuador',
  EG = 'Egypt',
  SV = 'El Salvador',
  GQ = 'Equatorial Guinea',
  ER = 'Eritrea',
  EE = 'Estonia',
  ET = 'Ethiopia',
  FK = 'Falkland Islands',
  FO = 'Faroe Islands',
  FJ = 'Fiji',
  FI = 'Finland',
  FR = 'France',
  GF = 'French Guiana',
  PF = 'French Polynesia',
  TF = 'French Southern Territories',
  GA = 'Gabon',
  GM = 'Gambia',
  GE = 'Georgia',
  DE = 'Germany',
  GH = 'Ghana',
  GI = 'Gibraltar',
  GR = 'Greece',
  GL = 'Greenland',
  GD = 'Grenada',
  GP = 'Guadeloupe',
  GU = 'Guam',
  GT = 'Guatemala',
  GG = 'Guernsey',
  GN = 'Guinea',
  GW = 'Guinea Bissau',
  GY = 'Guyana',
  HT = 'Haiti',
  HM = 'Heard Island Mcdonald Islands',
  VA = 'Holy See Vatican City State',
  HN = 'Honduras',
  HK = 'HongKong',
  HU = 'Hungary',
  IS = 'Iceland',
  IN = 'India',
  ID = 'Indonesia',
  IR = 'Iran',
  IQ = 'Iraq',
  IE = 'Ireland',
  IM = 'Isle Of Man',
  IL = 'Israel',
  IT = 'Italy',
  JM = 'Jamaica',
  JP = 'Japan',
  JE = 'Jersey',
  JO = 'Jordan',
  KZ = 'Kazakhstan',
  KE = 'Kenya',
  KI = 'Kiribati',
  KR = 'Korea, Republic of',
  KP = 'Korea, Democratic People\'s Republic of',
  KW = 'Kuwait',
  KG = 'Kyrgyzstan',
  LA = 'Lao Peoples Democratic Republic',
  LV = 'Latvia',
  LB = 'Lebanon',
  LS = 'Lesotho',
  LR = 'Liberia',
  LY = 'Libyan Arab Jamahiriya',
  LI = 'Liechtenstein',
  LT = 'Lithuania',
  LU = 'Luxembourg',
  MO = 'Macao',
  MG = 'Madagascar',
  MW = 'Malawi',
  MY = 'Malaysia',
  MV = 'Maldives',
  ML = 'Mali',
  MT = 'Malta',
  MH = 'Marshall Islands',
  MQ = 'Martinique',
  MR = 'Mauritania',
  MU = 'Mauritius',
  YT = 'Mayotte',
  MX = 'Mexico',
  FM = 'Micronesia',
  MD = 'Moldova',
  MC = 'Monaco',
  MN = 'Mongolia',
  ME = 'Montenegro',
  MS = 'Montserrat',
  MA = 'Morocco',
  MZ = 'Mozambique',
  MM = 'Myanmar',
  NA = 'Namibia',
  NR = 'Nauru',
  NP = 'Nepal',
  NL = 'Netherlands',
  NC = 'New Caledonia',
  NZ = 'New Zealand',
  NI = 'Nicaragua',
  NE = 'Niger',
  NG = 'Nigeria',
  NU = 'Niue',
  NF = 'Norfolk Island',
  MP = 'Northern Mariana Islands',
  NO = 'Norway',
  OM = 'Oman',
  PK = 'Pakistan',
  PW = 'Palau',
  PS = 'Palestinian Territory',
  PA = 'Panama',
  PG = 'Papua New Guinea',
  PY = 'Paraguay',
  PE = 'Peru',
  PH = 'Philippines',
  PN = 'Pitcairn',
  PL = 'Poland',
  PT = 'Portugal',
  PR = 'Puerto Rico',
  QA = 'Qatar',
  RE = 'Reunion',
  MK = 'Republic of North Macedonia',
  RO = 'Romania',
  RU = 'Russian Federation',
  RW = 'Rwanda',
  BL = 'Saint Barthelemy',
  SH = 'Saint Helena',
  KN = 'Saint Kitts And Nevis',
  LC = 'Saint Lucia',
  MF = 'Saint Martin',
  PM = 'Saint Pierre And Miquelon',
  VC = 'Saint Vincent And Grenadines',
  WS = 'Samoa',
  SM = 'San Marino',
  ST = 'Sao Tome And Principe',
  SA = 'Saudi Arabia',
  SN = 'Senegal',
  RS = 'Serbia',
  SC = 'Seychelles',
  SL = 'Sierra Leone',
  SG = 'Singapore',
  SK = 'Slovakia',
  SI = 'Slovenia',
  SB = 'Solomon Islands',
  SO = 'Somalia',
  ZA = 'South Africa',
  GS = 'South Georgia And Sandwich Island',
  ES = 'Spain',
  LK = 'Sri Lanka',
  SD = 'Sudan',
  SS = 'South Sudan',
  SR = 'Suriname',
  SJ = 'Svalbard And Jan Mayen',
  SZ = 'Swaziland',
  SE = 'Sweden',
  CH = 'Switzerland',
  SX = 'Sint Maarten (Dutch part)',
  SY = 'Syrian Arab Republic',
  TW = 'Taiwan',
  TJ = 'Tajikistan',
  TZ = 'Tanzania',
  TH = 'Thailand',
  TL = 'TimorLeste',
  TG = 'Togo',
  TK = 'Tokelau',
  TO = 'Tonga',
  TT = 'Trinidad And Tobago',
  TN = 'Tunisia',
  TR = 'Turkey',
  TM = 'Turkmenistan',
  TC = 'Turks And Caicos Islands',
  TV = 'Tuvalu',
  UG = 'Uganda',
  UA = 'Ukraine',
  AE = 'United Arab Emirates',
  GB = 'United Kingdom',
  US = 'United States',
  UM = 'United States Outlying Islands',
  UY = 'Uruguay',
  UZ = 'Uzbekistan',
  VU = 'Vanuatu',
  VE = 'Venezuela',
  VN = 'Vietnam',
  VG = 'Virgin Islands British',
  VI = 'Virgin Islands US',
  WF = 'Wallis And Futuna',
  EH = 'Western Sahara',
  YE = 'Yemen',
  ZM = 'Zambia',
  ZW = 'Zimbabwe',
}
